import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Divider from "components/common/Divider";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { makeStyles } from "@mui/styles";
import React from "react";
import { result } from "lodash";
import { CircularProgress } from "@mui/material";

const DashboardCustomer = (props, Img404) => {
  const classes = useStyles();
  return (
    <>
      <Card sx={{ minHeight: "350px" }}>
        {props.isLoadingcustomerdata ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
              height: "20vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <CardContent>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Text className={classes.graphheading}>Customers</Text>

              <Box>
                <Stack direction="row" spacing={2}>
                  <Text className={classes.dateheading}>
                    {props?.total?.result?.since}-{props?.total?.result?.to}
                  </Text>
                </Stack>
              </Box>
            </Stack>

            <Divider
              sx={{ marginTop: "27px", marginBottom: "15px" }}
              variant="middle"
            />
            <Box>
              <Stack direction="row" spacing={2}>
                <Text className={classes.totalheading}>Total Customers :</Text>
                <Text
                  sx={{
                    marginLeft: "6px!important",
                    marginTop: "1px!important",
                  }}
                  className={classes.valueheading}
                >
                  {props?.total?.result?.total_customers
                    ? props?.total?.result?.total_customers
                    : "0"}
                </Text>
              </Stack>
            </Box>
            {props == null ? (
              <>
                
                <h1>Data Not Found </h1> <img src={Img404} alt="" />
              </>
            ) : (
              ""
            )}
            <HighchartsReact
              highcharts={Highcharts}
              options={props !== null ? props.options : " "}
            />
          </CardContent>
        )}
      </Card>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  HighchartsFirst: {
    "& .highcharts-container": {
      width: "100% !important",
    },
    "& .highcharts-root": {
      width: "100% !important",
    },
  },
  customSelect: {
    height: "40px !important",
    margin: 0,
    "& .MuiListItemText-primary": { fontSize: "14px !important" },
  },
  breadcrumbs: {
    fontSize: "14px",
    marginBottom: "20px",
    marginTop: "10px",
  },

  graphheading: {
    fontSize: "15px",
    color: "#545454",
    letterSpacing: "0.09px",
    textTransform: "uppercase",
    font: "Nunito Sans",
    fontWeight: "bold",
  },
  dateheading: {
    fontSize: "14px",
    color: "#B4B4BE",
    font: "Nunito Sans",
  },
  totalheading: {
    fontSize: "12px",
    color: "#7E84A3",
    fontWeight: "600",
    font: "Nunito Sans",
  },
  valueheading: {
    fontSize: "12px",
    color: "#545454",
    fontWeight: "600",
    font: "Nunito Sans",
  },
}));

export default DashboardCustomer;
